module.exports = __webpack_public_path__ + "static/town-hall-project-e73c7cded90b1798ee382f4affb47ba8.png";